import { prV2QueryKeyPrefix } from './query-keys';

export function prV2ReactionMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'reactions'] as const;
}

export function prV2CommentCreateMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'comment-create'] as const;
}

export function prV2CommentReplyMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'comment-reply'] as const;
}

export function prV2CommentEditMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'comment-edit'] as const;
}

export function prV2CommentResolveMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'comment-resolve'] as const;
}

export function prV2ReviewSubmitMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'review-submit'] as const;
}

export function prV2ReviewerMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'reviewers'] as const;
}

/**
 * Shared by every usePrV2UpdateState instance for one PR (actions menu, hotkeys, inbox menu), so
 * each can see a close/reopen/draft change started from another.
 */
export function prV2UpdateStateMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'update-state'] as const;
}

/**
 * Shared by every inbox merge of one PR (its row's button and menu, the selected row's key and the
 * command menu), so none starts a second merge while another runs.
 */
export function prV2InboxMergeMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'inbox-merge'] as const;
}

/**
 * Shared by the demo card's re-record and every read of the demo (`usePrV2Demo`), which shows the
 * demo awaiting its take while one is asked for.
 */
export function prV2DemoRerecordMutationKey(owner: string, repo: string, number: string) {
  return [...prV2QueryKeyPrefix(owner, repo, number), 'demo-rerecord'] as const;
}
